import React from 'react';

const CommonModal = () => {
	return (
		<div>
			<div className="wraper container-fluid dashboard-container">
				<div className="popup-wrapper">
					{/* supplier-upload-modal */}
					<div className="common-popup products-upload-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Your Key Product (Garments)</h3>
							</div>
							<div className="close-btn">
								<img alt="close" src=" /icons/close.svg" />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="upload-img mb-2">
										<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
											<label className="drag-upload" htmlFor="drag-upload" />
											<input
												accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
												className="file-upload"
												name="image"
												type="file"
											/>
										</div>
										{/* <div class="file-editing">
                    <img src=" /images/supplier2.jpg" alt="edit">
                    <div class="action-icon">
                        <img width="20px" src=" /icons/upload-gray.svg" alt="check">
                    </div>
                </div> */}
									</div>
								</div>
								<div className="col-md-6 pr-2">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Fabric Type*</label>
											<div className="click-box click mb-1" data-toggle="dropdown">
												<p className="regular-14 ">select</p>
												<img src=" /images/chevron_down.svg" />
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input placeholder="Search" type="text" />
														<span className="right-icon">
															<img src=" /icons/search.png" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Garments</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group composition-item mb-0">
										<label>Weight*</label>
										<div className="d-flex">
											<input
												className="input-percentage"
												max={100}
												min="0.1"
												type="number"
												defaultValue
											/>
											<p className="percentage">%</p>
											<div className="select-component">
												<div className="form-group size36">
													<div className="select-component">
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															tabIndex={0}
														>
															<p className="regular-14 ">Composition</p>
															<img alt="" src=" /images/chevron_down.svg" />
														</div>
														<div data-testid="wrapper">
															<div className="dropdown-box  dropdown-menu">
																<div className="m-0 search-filter">
																	<div className="with-icon right-icon">
																		<input
																			autoComplete="off"
																			placeholder="Composition"
																			type="text"
																			defaultValue
																		/>
																		<span className="right-icon">
																			<img src=" /icons/search.png" />
																		</span>
																	</div>
																</div>
																<div className="color-list-box">
																	<li className="single-color-item single-item d-flex ">
																		<span
																			className="single-item-focus"
																			tabIndex={0}
																		>
																			Nylon
																		</span>
																	</li>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group composition-item mb-0">
										<label>Composition*</label>
										<div className="d-flex">
											<input
												className="input-percentage"
												max={100}
												min="0.1"
												type="number"
												defaultValue
											/>
											<p className="percentage">%</p>
											<div className="select-component">
												<div className="form-group size36">
													<div className="select-component">
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															tabIndex={0}
														>
															<p className="regular-14 " />
															<img alt="" src=" /images/chevron_down.svg" />
														</div>
														<div data-testid="wrapper">
															<div className="dropdown-box  dropdown-menu">
																<div className="m-0 search-filter">
																	<div className="with-icon right-icon">
																		<input
																			autoComplete="off"
																			placeholder="Composition"
																			type="text"
																			defaultValue
																		/>
																		<span className="right-icon">
																			<img src=" /icons/search.png" />
																		</span>
																	</div>
																</div>
																<div className="color-list-box">
																	<li className="single-color-item single-item d-flex ">
																		<span
																			className="single-item-focus"
																			tabIndex={0}
																		>
																			Nylon
																		</span>
																	</li>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group composition-item mb-0">
										<label className="invisible">.</label>
										<div className="d-flex">
											<input
												className="input-percentage"
												max={100}
												min="0.1"
												type="number"
												defaultValue
											/>
											<p className="percentage">%</p>
											<div className="select-component">
												<div className="form-group size36">
													<div className="select-component">
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															tabIndex={0}
														>
															<p className="regular-14 " />
															<img alt="" src=" /images/chevron_down.svg" />
														</div>
														<div data-testid="wrapper">
															<div className="dropdown-box  dropdown-menu">
																<div className="m-0 search-filter">
																	<div className="with-icon right-icon">
																		<input
																			autoComplete="off"
																			placeholder="Composition"
																			type="text"
																			defaultValue
																		/>
																		<span className="right-icon">
																			<img src=" /icons/search.png" />
																		</span>
																	</div>
																</div>
																<div className="color-list-box">
																	<li className="single-color-item single-item d-flex ">
																		<span
																			className="single-item-focus"
																			tabIndex={0}
																		>
																			Nylon
																		</span>
																	</li>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6 pr-2">
									<div className="form-group">
										<label htmlFor="collection">Price</label>
										<input type="text" />
									</div>
								</div>
								<div className="col-md-6 pr-2">
									<div className="form-group">
										<label htmlFor="collection">Fabric Reference Number</label>
										<input type="text" />
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2">Submit</button>
								<button className="button size32 ml-2">Submit</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CommonModal;
